import classNames from 'classnames';
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import styles from './style.module.scss';
import { PlusIcon, ProjectNameIcon, StatusCheckIcon, EyeIcon, DetailIcon, UserIcon, DownloadIcon } from 'assets';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import GenericTable from 'shared/components/common/table/table';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import Heading from 'shared/components/common/heading/Heading';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import AddClient from 'shared/modal/add_product/AddProduct';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import moment from 'moment';
import { isRestrictActions } from 'shared/utils/Helper';
import { screenActionEnum, screenEnum } from 'shared/utils/Enum';
import { routeConstant } from 'shared/routes/RouteConstant';
import { GetAllInventoryQuery } from 'shared/services/inventory_service/InventoryService';
import UpdateInvenotyMod from 'shared/modal/update_inventory/UpdateInvenotyMod';
import SearchBar from 'shared/components/common/searchbar/SearchBar';
import ExcelExport from 'shared/components/common/ExcelExport/ExcelExport';
import InventoySearchBar from 'shared/components/common/searchbar/Inventory';
import Select from 'react-select';
import { GetAllWarehouse } from 'shared/services/ware_house_service/WareHouseService';


const handlePrintBarcode = (sku) => {
    const printWindow = window.open('', 'PRINT', 'height=250,width=300');
    const htmlContent = `
    <html>
      <head>
        <title>Print Barcode</title>
        <style>
          @media print {
            @page {
              size: 25.08mm 18.28mm; /* exact barcode sticker size */
              margin: 0;
            }
            body {
              margin: 0;
              padding: 0;
            }
          }

          body {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 25.08mm;
            height: 18.28mm;
            margin: 0;
            font-family: Arial, sans-serif;
            overflow: hidden;
          }

          #barcode-svg {
            width: 24mm !important;
            height: 12mm !important;
          }

          .barcode-label {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }

          .sku-text {
            font-size: 7px;
            margin-top: 1mm;
          }
        </style>
      </head>
      <body>
        <div class="barcode-label">
          <svg id="barcode-svg"></svg>
          <div class="sku-text"><b>SKU</b>:${sku}</div>
        </div>

        <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
        <script>
          JsBarcode("#barcode-svg", "${sku}", {
            format: "CODE128",
            lineColor: "#000",
            width: 1,
            height: 12,
            displayValue: false
          });

          window.onload = function() {
            window.print();
            window.onafterprint = function() { window.close(); };
          };
        </script>
      </body>
    </html>
  `;
    printWindow.document.write(htmlContent);
    printWindow.document.close();
};



export default function Inventory() {
    const { theme: { theme } } = useSelector((state) => state.root);
    const navigate = useNavigate();
    const [openProduct, setOpenProduct] = useState(false);
    const [openinventory, setOpeninventory] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [wareHouses, setWareHouses] = useState([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState();

    const { isLoading, data: InventoryList } = GetAllInventoryQuery();
    const { data: listWareHouse } = GetAllWarehouse();


    // 1. Warehouse options ko alag useEffect mein rakhein (Only once on load)
    useEffect(() => {
        if (listWareHouse) {
            const options = listWareHouse.map((w) => ({
                ...w,
                label: w?.code,
                value: w?._id,
            }));
            setWareHouses(options);

            // Default set karein sirf tab jab pehle se kuch na ho
            if (options.length > 0 && !selectedWarehouse) {
                setSelectedWarehouse(options[0]);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listWareHouse]); // Warehouse list aane par sirf ek baar chale


    // 2. Inventory Filtering ko alag rakhein
    useEffect(() => {
        if (InventoryList) {
            let filtered = [...InventoryList];

            if (selectedWarehouse && selectedWarehouse.value) {
                filtered = filtered.filter(item =>
                    String(item?.warehouse?._id) === String(selectedWarehouse.value)
                );
            }

            setFilteredData(filtered);
        }
    }, [InventoryList, selectedWarehouse]); // Jab Inventory aaye ya Warehouse badle tab chale


    const navigateToPath = useCallback(() => {
        navigate(routeConstant.admin.inventory.upinventory.path);
    }, [navigate]);

    const details = useCallback((data) => {
        navigate(routeConstant.admin.inventory.detailinventory.path, { state: { data } });
    }, [navigate]);

    const closeProductHandler = useCallback(() => {
        setOpenProduct(false);
        setOpeninventory(false);
    }, []);

    const columns = useMemo(
        () => [

            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <UserIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        SKU
                    </div>
                ),
                accessor: 'sku',
                Cell: ({ row }) => <div>{row.original?.sku}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Compatible Brand
                    </div>
                ),
                accessor: 'dd',
                Cell: ({ row }) => <div>{row.original?.compatiableBrand?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Product Name
                    </div>
                ),
                accessor: 'name',
                Cell: ({ row }) => <div>{row.original?.product?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Product SubCategory
                    </div>
                ),
                accessor: 'SubCategory',
                Cell: ({ row }) => <div>{row.original?.sub_category?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Color
                    </div>
                ),
                accessor: 'color',
                Cell: ({ row }) => <div>{row.original?.color}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Product Category
                    </div>
                ),
                accessor: 'product_category',
                Cell: ({ row }) => <div>{row.original?.product_category?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Brand
                    </div>
                ),
                accessor: 'brand',
                Cell: ({ row }) => <div>{row.original?.brand?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Issue Date
                    </div>
                ),
                accessor: 'created_at',
                Cell: ({ row }) => <div>{moment(row.original?.po?.created_at || row.original?.created_at).format('DD, MMM YYYY')}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        In Stock
                    </div>
                ),
                accessor: 'quantity',
                Cell: ({ row }) => <div>{row.original?.quantity}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Warehouse
                    </div>
                ),
                accessor: 'ware',
                Cell: ({ row }) => <div>{row.original?.warehouse?.code}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <DownloadIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Print Barcode
                    </div>
                ),
                accessor: 'print_barcode',
                Cell: ({ row }) => (
                    <button className={styles.PrintButton} onClick={() => handlePrintBarcode(row.original?.sku)}>
                        Print
                    </button>
                )
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <DetailIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        View Detail
                    </div>
                ),
                accessor: 'view&print',
                Cell: ({ row }) => <EyeIcon cursor="pointer" onClick={() => details(row.original)} />
            },
        ],
        [theme, details]
    );

    const handleSearchChange = useCallback((filteredFromSearch) => {
        // Agar warehouse selected hai, toh search result ko bhi warehouse par filter karein
        let finalDisplay = filteredFromSearch;
        if (selectedWarehouse) {
            finalDisplay = filteredFromSearch.filter(item =>
                String(item?.warehouse?._id) === String(selectedWarehouse.value)
            );
        }
        setFilteredData(finalDisplay);
    }, [selectedWarehouse]);

    const handleWarehouseChange = useCallback((item) => {
        setSelectedWarehouse(item);
    }, []);

    const handleSubmitInventory = useCallback(() => {
        if (isRestrictActions(screenEnum.inventory, screenActionEnum.create)) {
            navigateToPath();
        }
    }, [navigateToPath]);

    return (
        <DashboardWrapper>
            <div className={classNames(styles.UserContainer, 'text-start')}>
                <InventoySearchBar
                    searchKey="sku"
                    suggestionsSource={InventoryList || []}
                    onSearchChange={handleSearchChange}
                />

                <div className={styles.Header}>
                    <Heading heading={'Inventory'} headingStyle={styles.Heading} />
                    <div className={styles.HeaderActions}>
                        <Select
                            placeholder="Filter by Warehouse"
                            isClearable
                            options={wareHouses}
                            value={selectedWarehouse}
                            onChange={handleWarehouseChange}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                                control: (provided, state) => ({
                                    ...provided,
                                    minWidth: 220,
                                    height: '40px',
                                    minHeight: '40px',
                                    borderRadius: '6px',
                                    border: state.isFocused ? '1px solid #4a86f7' : '1px solid #c9d1e1',
                                    boxShadow: state.isFocused ? '0 0 0 1px #4a86f7' : 'none',
                                    '&:hover': { border: '1px solid #4a86f7' },
                                    cursor: 'pointer',
                                }),
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 9999,
                                }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                        />
                        <CustomButton
                            Icon={PlusIcon}
                            submitHandle={handleSubmitInventory}
                            IconStyle={classNames('me-1', styles.IconStyle)}
                            text={'Inventory'}
                            containerStyle={classNames(styles.AddProduct)}
                        />
                        <ExcelExport data={InventoryList} fileName={'Inventory List'} />
                    </div>
                </div>

                <GenericTable columns={columns} data={filteredData || []} TableWrapperStyle={classNames(styles.Table)} />
                <AddClient show={openProduct} handleClose={closeProductHandler} />
            </div>
            {isLoading && <OverlayLoading />}
        </DashboardWrapper>
    );
}
